
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { coloresCarrito, unidadesMedida } from "../../../data";
import { useCalcularPrecios, separadorMillares } from "../../../hooks";
import { AgregarTerminados } from "../components";
import { SelectSencillo, TextFormField, ViewPrecioRolMinimoSeis } from "../../components";
import { buscarProductoCorteVinilo } from "../../../helpers/FormulariosCarrito";
import { useProductosStore } from "../../../stores";

import Swal from "sweetalert2";
const basePrecio = +process.env.REACT_APP_PRECIO_BASE;




export const FormularioCorteVinilo = ({ formCarrito, setFormCarrito, funcionAgregar, poducto, 
                                        titulo='Agregar Producto', carrito, medida=6 }) => {


    const { activarTerminado } = useProductosStore();
    const { calcularPreciosTerminados } = useCalcularPrecios();
    const [ precioReal, setPrecioReal ] = useState(0);



    useEffect(() => {
        if(poducto){
            const { cliente, distri, empresa, publicista, precioReal }  = calcularPreciosTerminados( formCarrito.unidadMedida, formCarrito.alto, formCarrito.ancho, formCarrito.cantidad, poducto, activarTerminado);
            setPrecioReal( precioReal - cliente );
            setFormCarrito({
                ...formCarrito,
                totalCliente: (cliente < 1000) ? basePrecio : Math.ceil(cliente),
                totalDistri: (distri < 1000) ? basePrecio : Math.ceil(distri),
                totalEmpresa: (empresa < 1000) ? basePrecio : Math.ceil(empresa),
                totalPublicista: (publicista < 1000) ? basePrecio : Math.ceil(publicista),
            });
        }
    }, [activarTerminado, formCarrito.unidadMedida, formCarrito.alto, formCarrito.ancho, formCarrito.producto, formCarrito.cantidad, poducto]);




    useEffect(() => {
        if( formCarrito.color === '' ){ return }

        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
        Toast.fire({ icon: 'question', title: 'Los Productos y Colores dependen de disponibilidad de stock' });
    }, [formCarrito.color]);




    const handleInputChange = ({ target }) => {
        setFormCarrito({
            ...formCarrito,
            [target.name]: target.value
        });
    }



    const handleAgregarAlCarro = (e) => {
        e.preventDefault();
        if( [formCarrito.cantidad, formCarrito.unidadMedida, formCarrito.alto, formCarrito.ancho, formCarrito.color].includes('') ) { 
            return Swal.fire('Error', 'La cantidad, unidad de medida, alto y ancho son campos obligatorios.', 'error') 
        }


        const product = buscarProductoCorteVinilo(carrito, formCarrito.producto, 
            formCarrito.color, formCarrito.unidadMedida, formCarrito.alto, formCarrito.ancho);
        funcionAgregar(product)
    }




    return (

        <form onSubmit={ handleAgregarAlCarro } style={{ width:'100%' }}>
            <Grid container sx={{mt:0}} spacing={2}>
                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label={`Cantidad`}
                        type='number'
                        placeholder="Cantidad"
                        name="cantidad"
                        value={formCarrito.cantidad}
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={medida}>
                    <SelectSencillo
                        size="small"
                        label="Unidad de Medidad"
                        name="unidadMedida"
                        value={ formCarrito.unidadMedida }
                        onChange={ handleInputChange } 
                        options={unidadesMedida}
                    />
                </Grid>

                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label='Ancho'
                        type='number'
                        placeholder="Ancho"
                        name="ancho"
                        value={formCarrito.ancho}
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label='Alto'
                        type='number'
                        placeholder="Alto"
                        name="alto"
                        value={formCarrito.alto}
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12}>
                    <SelectSencillo
                        size="small"
                        label="Color"
                        name="color"
                        value={formCarrito.color}
                        onChange={ handleInputChange } 
                        options={coloresCarrito}
                    />
                </Grid>

                <AgregarTerminados formCarrito={formCarrito} setFormCarrito={setFormCarrito} />

            </Grid>

            {/* Mostrar Precio Segun Rol */}
            <ViewPrecioRolMinimoSeis formCarrito={formCarrito} />

            <Grid container sx={{ mt:1 }} spacing={2}>
                <Grid item xs={12} sm={(precioReal <= 0) ? 12 : medida}>
                    <Button type="submit" color='primary' variant="contained" fullWidth>{ titulo }</Button>
                </Grid>

                {(precioReal > 0) && (
                <Grid item xs={12} sm={medida}>
                    <Button color='secondary' variant="contained" fullWidth>
                        Ahorra { `$${ separadorMillares( precioReal ) }`}
                    </Button>
                </Grid>
                )}
            </Grid>
        </form> 
    )
}
